import CroustilleElement from '../lib/CroustilleElement'

const template = `
<style>
  :host {
    position: relative;
    z-index: 0;
  }
  button {
    position: absolute;
    bottom: 0;
    appearance: none;
    font-size: inherit;
    color: inherit;
    background: transparent;
    padding: 0;
    cursor: pointer;
    border: 0;
    box-shadow: 0;
    width: 1em;
    z-index: 10;
  }
  button:focus {
    outline: 0;
    box-shadow: 0;
  }
  button:first-of-type {
    left: 0;
    top: -0.125em;
  }
  button:last-of-type {
    right: 0;
    top: 0.03125em;
  }
  [aria-hidden="true"] {
    visibility: hidden;
    padding: 0 1em;
  }
  [data-slot] {
    display: inline-block;
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
</style>
<button>-</button>
<span aria-hidden="true"></span>
<span data-slot><slot></slot></span>
<button>+</button>
`

class InputNumber extends CroustilleElement {
  constructor() {
    super('input-number')

    this.shadow = this.attachShadow({ mode: 'open' })
    const container = document.createElement('span')
    container.innerHTML = template
    this.shadow.appendChild(container)
  }

  get input() {
    return this.querySelector('input[type="number"]')
  }

  get buttons() {
    return this.shadow.querySelectorAll('button')
  }

  get down() {
    return this.buttons[0]
  }

  get up() {
    return this.buttons[1]
  }

  stepDown() {
    this.input.stepDown()
    this.onKeyUp()
  }

  stepUp() {
    this.input.stepUp()
    this.onKeyUp()
  }

  get placeholder() {
    return this.shadow.querySelector(':host > span > span')
  }

  onKeyUp() {
    this.placeholder.innerHTML = this.input.value
    // trigger real change event for Woocommerce
    this.input.dispatchEvent(new Event('change', { bubbles: true }))
  }

  init() {
    this.stepDown = this.stepDown.bind(this)
    this.stepUp = this.stepUp.bind(this)
    this.onKeyUp = this.onKeyUp.bind(this)

    this.down.addEventListener('click', this.stepDown)
    this.up.addEventListener('click', this.stepUp)
    this.input.addEventListener('input', this.onKeyUp)
    this.onKeyUp()
  }

  destroy() {
    this.down.removeEventListener('click', this.stepDown)
    this.up.removeEventListener('click', this.stepUp)
    this.input.removeEventListener('input', this.onKeyUp)
  }
}

export default InputNumber
